import * as React from "react";

const CheckWrapper = (props: { children: any }) => (
    <div>
        <label className="d-inline-flex align-items-center py-2" >
            {props.children}
        </label>
    </div>
);
export { CheckWrapper };